import { PageCard } from "src/common/styles/styles"
import { NotificationsCard } from "../../NotificationsCard"
import { formatToCurrency, formatToDisplayDate } from "src/common/util"
import { PayableContract } from "src/common/models/payableContract"
import { Empty } from "antd"
import { SystemConstants } from "src/common/constants"

interface Props {
    title: string
    data: PayableContract[]
}

const availableColors: string[] = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
]

export const FuturePayments = (props: Props) => {

    const dictionaryOfServiceColors = {}

    return <PageCard
        title={props.title}
        size="small"
    >
        {
            props.data.length === 0
                ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={`No hay pagos para los próximos ${SystemConstants.NEXT_SERVICE_DEBIT_RANGE} dias`} />
                : <NotificationsCard
                    data={props.data.map((nextPayment, idx) => {

                        if (!dictionaryOfServiceColors[nextPayment.serviceCategoryId]) {
                            dictionaryOfServiceColors[nextPayment.serviceCategoryId] = availableColors[Math.floor(Math.random() * availableColors.length)]
                        }

                        return {
                            notification_id: nextPayment.id?.toString() || `${idx}`,
                            notification_date: formatToDisplayDate(nextPayment.nextServiceDebit),
                            notification_total: formatToCurrency(nextPayment.total.toString(), "GTQ"),
                            notification_message: nextPayment.description,
                            notification_category: nextPayment.serviceCategory || 'NA',
                            color: dictionaryOfServiceColors[nextPayment.serviceCategoryId],
                        }
                    })
                    }
                />
        }
    </PageCard>

}
